module.exports = __webpack_public_path__ + "img/RASP2.4f67a552.png";